export const dashboardEn = {
  // shared — DashboardNav
  'dashboard.nav.ariaLabel': 'Dashboard sections',
  'dashboard.nav.overview': 'Overview',
  'dashboard.nav.avatar': 'Avatar',
  'dashboard.nav.coins': 'Coins',
  'dashboard.nav.contributions': 'Contributions',

  // shared — StatusBadge (contribution status)
  'dashboard.status.draft': 'Draft',
  'dashboard.status.submitted': 'Submitted',
  'dashboard.status.communityReview': 'Community Review',
  'dashboard.status.officialReview': 'Official Review',
  'dashboard.status.approved': 'Approved',
  'dashboard.status.rejected': 'Rejected',
  'dashboard.status.unknown': 'unknown',

  // shared — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'pending',
  'dashboard.claimStatus.approved': 'approved',
  'dashboard.claimStatus.rejected': 'rejected',

  // DashboardPage
  'dashboard.seo.title': 'My Grymwyrd',
  'dashboard.seo.description': 'Your coins, claims, contributions, and characters in the eternal twilight.',
  'dashboard.displayNameFallback': 'Wanderer',
  'dashboard.welcomeBack': 'Welcome back',
  'dashboard.editAvatar': 'Edit avatar',
  'dashboard.loading': 'Gathering your legend…',
  'dashboard.avatarAlt': "{name}'s portrait",
  'dashboard.offlineNotice':
    'Live profile data is unavailable — showing your last-known session and sample content.',

  // DashboardPage — Coins card
  'dashboard.coins.title': 'Grave Coins',
  'dashboard.coins.viewAll': 'View all',
  'dashboard.coins.unit': 'coins',
  'dashboard.coins.noActivity': 'No coin activity yet.',
  'dashboard.coins.fullHistory': 'Full history & buy coins',

  // DashboardPage — Contributions card
  'dashboard.contributions.title': 'Contributions',
  'dashboard.contributions.manage': 'Manage',
  'dashboard.contributions.empty': 'No contributions yet — pen your first.',

  // DashboardPage — Claims card
  'dashboard.claims.title': 'Claimed World Spots',
  'dashboard.claims.empty': 'You hold no ground in Grymwyrd yet.',
  'dashboard.claims.kindClaimed': '{kind} · claimed {date}',

  // DashboardPage — Characters card
  'dashboard.characters.title': 'Characters',
  'dashboard.characters.empty': 'No souls bound to your name.',
  'dashboard.characters.level': 'Lv {level}',
  'dashboard.characters.unknown': 'Unknown',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Avatar Editor',
  'dashboard.avatarEditor.seo.description': 'Shape the face you show the world of Grymwyrd.',
  'dashboard.avatarEditor.heading': 'Avatar Editor',
  'dashboard.avatarEditor.errorNotImage': 'That file is not an image.',
  'dashboard.avatarEditor.errorNameRequired': 'A name is required, even in the dark.',
  'dashboard.avatarEditor.portrait': 'Portrait',
  'dashboard.avatarEditor.portraitPreview': 'Portrait preview',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Avatar preview',
  'dashboard.avatarEditor.zoom': 'Zoom',
  'dashboard.avatarEditor.zoomAria': 'Zoom portrait',
  'dashboard.avatarEditor.panHorizontal': 'Pan portrait horizontally',
  'dashboard.avatarEditor.panVertical': 'Pan portrait vertically',
  'dashboard.avatarEditor.uploadAria': 'Upload portrait image',
  'dashboard.avatarEditor.changeImage': 'Change image',
  'dashboard.avatarEditor.uploadImage': 'Upload image',
  'dashboard.avatarEditor.identity': 'Identity',
  'dashboard.avatarEditor.displayName': 'Display name',
  'dashboard.avatarEditor.backstory': 'Backstory',
  'dashboard.avatarEditor.backstoryPlaceholder': 'Whence came you, and what dark fate do you court?',
  'dashboard.avatarEditor.publicProfile': 'Public profile',
  'dashboard.avatarEditor.publicVisible': 'Visible in the Hall of Legends.',
  'dashboard.avatarEditor.publicHidden': 'Hidden from other wanderers.',
  'dashboard.avatarEditor.saving': 'Saving…',
  'dashboard.avatarEditor.saveChanges': 'Save changes',
  'dashboard.avatarEditor.saved': 'Saved',
  'dashboard.avatarEditor.starting.heading': 'Choose a starting face',
  'dashboard.avatarEditor.starting.hint': 'Pick a portrait to start with. You can upload your own at any time.',
  'dashboard.avatarEditor.starting.all': 'All lineages',
  'dashboard.avatarEditor.starting.filterAria': 'Filter portraits by lineage',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Checkout is not available yet — the coffers remain locked.',
  'dashboard.coinHistory.notEnoughCoins': 'Not enough coins for that.',
  'dashboard.coinHistory.spendFailed': "That purchase didn't complete. Check your coin balance before trying again.",
  'dashboard.coinHistory.reasonWorldClaim': 'World claim',
  'dashboard.coinHistory.reasonCosmetic': 'Cosmetic',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': 'Spent {cost} coins on {name}.',
  'dashboard.coinHistory.seo.title': 'Grave Coins',
  'dashboard.coinHistory.seo.description': 'Your full coin ledger, top-ups, and the wares of the dead.',
  'dashboard.coinHistory.heading': 'Grave Coins',
  'dashboard.coinHistory.balance': 'balance',
  'dashboard.coinHistory.buyCoins': 'Buy Coins',
  'dashboard.coinHistory.packCoins': '{coins} coins',
  'dashboard.coinHistory.packBonus': ' + {bonus} bonus',
  'dashboard.coinHistory.summoningCheckout': 'Summoning checkout…',
  'dashboard.coinHistory.purchase': 'Purchase',
  'dashboard.coinHistory.spendCoins': 'Spend Coins',
  'dashboard.coinHistory.insufficientCoins': 'Insufficient coins',
  'dashboard.coinHistory.spending': 'Spending…',
  'dashboard.coinHistory.spendAmount': 'Spend {cost}',
  'dashboard.coinHistory.historyTitle': 'History',
  'dashboard.coinHistory.tallyingLedger': 'Tallying the ledger…',
  'dashboard.coinHistory.tableCaption': 'Coin transaction history',
  'dashboard.coinHistory.colReason': 'Reason',
  'dashboard.coinHistory.colAmount': 'Amount',
  'dashboard.coinHistory.noTransactions': 'No transactions yet.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'My Contributions',
  'dashboard.contributionsPage.seo.description':
    'The lore you have penned, and its passage through the moderators’ gaze.',
  'dashboard.contributionsPage.heading': 'Contributions',
  'dashboard.contributionsPage.newContribution': 'New Contribution',
  'dashboard.contributionsPage.loading': 'Unrolling your scrolls…',
  'dashboard.contributionsPage.empty': 'You have penned no lore yet. Begin your first contribution.',
  'dashboard.contributionsPage.untitledDraft': 'Untitled draft',
  'dashboard.contributionsPage.moderator': 'Moderator:',
  'dashboard.contributionsPage.entryFallback': 'Entry',
  'dashboard.contributionsPage.errorNameRequired': 'Every creation needs a name.',
  'dashboard.contributionsPage.modalTitle': 'New Contribution',
  'dashboard.contributionsPage.type': 'Type',
  'dashboard.contributionsPage.titleLabel': 'Title',
  'dashboard.contributionsPage.summaryLabel': 'Summary',
  'dashboard.contributionsPage.saveDraft': 'Save draft',
  'dashboard.contributionsPage.submitting': 'Submitting…',
  'dashboard.contributionsPage.submitForReview': 'Submit for review',
} as const
